import { Message } from 'antd';
import { ldb } from "../../plugins/utils.js";
import { httpSetToken } from '../../plugins/http.js';
import { login, register, resetPassword, matchLogin } from '../../api/index.js';

export function setToken(token) {
  return async (dispatch) => {
    if (!token) {
      console.log("Token 不存在");
    } else {
      ldb.save('token', token);
      dispatch({ type: 'SET_TOKEN', payload: { token: token.token, userInfo: token.user} });
    }
  };
}

export function match(payload) {
  return async (dispatch) => {
    let res = await matchLogin(payload.info);
    if (res.code === 200) {
      if (res.output.user.role_id === 1) {
        httpSetToken(res.output.token);
        ldb.save('token', res.output);
        dispatch({type: 'SET_TOKEN', payload: res.output});
        if (ldb.get('url')) {
          let url = ldb.get('url');
          window.location.href = url;
          return;
        }
        payload.history.replace(`/course/${payload.id}`);
        return
      }
      Message.warn('请使用学生账号登录！');
    } else {
      Message.error(res.tip);
      payload.history.replace('/login');
    }
  }
}

export function userLogin(payload) {
	return async (dispatch) => {
    let res = await login(payload.info);
    if (res.code === 200) {
      if (res.output.user.role_id === 1) {
        httpSetToken(res.output.token);
        ldb.save('token', res.output);
        dispatch({type: 'SET_TOKEN', payload: res.output});
        if (ldb.get('url')) {
          let url = ldb.get('url');
          window.location.href = url;
          return;
        }
        payload.history.replace('/user/center');
        return
      }
      Message.warn('请使用学生账号登录！');
    } else {
      Message.error(res.tip);
    }
  }
}

export function regist(payload) {
  return async (dispatch) => {
    let res = await register(payload.info);
    if (res.code === 200) {
      if (res.output.user.role_id === 1) {
        httpSetToken(res.output.token);
        ldb.save('token', res.output);
        dispatch({type: 'SET_TOKEN', payload: res.output});
        if (ldb.get('url')) {
          let url = ldb.get('url');
          window.location.href = url;
          return;
        }
        payload.history.replace('/user/center');
        return
      }
    } else {
      Message.error(res.tip);
    }
  }
}

export function retrievePassword(payload) {
  return async (dispatch) => {
    let res = await resetPassword(payload.info);
    if (res.code === 200) {
      if (res.output.user.role_id === 1) {
        httpSetToken(res.output.token);
        ldb.save('token', res.output);
        dispatch({type: 'SET_TOKEN', payload: res.output});
        payload.history.replace('/user/center');
        return
      }
    } else {
      Message.error(res.tip);
    }
  }
}

export function logout(payload) {
  return async (dispatch) => {
    dispatch({type: 'REMOVE_TOKEN', payload: { token: '', userInfo: '', product: '' }});
    payload.push('/login');
  }
}

export function setProduct(payload) {
  return async (dispatch) => {
    dispatch({type: 'PRODUCT', payload: { product: payload }});
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/user.js